export default __webpack_public_path__ + "static/media/announcer-initiatingmatch.819b0838.mp3";